import React, { useState } from 'react';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBars,
  faCalendarAlt,
  faCog,
  faHandsHelping,
  faUser,
  faUserPlus,
  faSignOutAlt,
} from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';

const SidebarLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await axios.get('https://api.remindly.gr/logout.php', {
        withCredentials: true,
      });
      navigate('/auth', {
      state: { message: 'Αποσυνδέθηκες επιτυχώς.' }
      });
    } catch (err) {
      console.error('Logout failed', err);
    }
  };

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar */}
      <aside
        className={`bg-gray-100 fixed top-0 left-0 z-50 h-full p-4 transition-all duration-300 shadow-md
        ${sidebarOpen ? 'w-64' : 'w-16'} flex flex-col items-start`}
      >
        {/* Logo & Toggle */}
        <div className="flex flex-col items-center w-full mb-6">
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="text-gray-600 hover:text-indigo-600 mb-4"
          >
            <FontAwesomeIcon icon={faBars} size="lg" />
          </button>

          {sidebarOpen && (
            <span className="text-xl font-bold text-indigo-600">Remindly</span>
          )}
        </div>

        {/* Navigation */}
        <nav className="flex flex-col gap-4 w-full">
          <Link to="/calendar" className="flex items-center gap-3 px-2 py-2 hover:bg-indigo-100 rounded w-full">
            <FontAwesomeIcon icon={faCalendarAlt} className="text-indigo-600 text-lg" />
            {sidebarOpen && <span>Ημερολόγιο</span>}
          </Link>

          <Link to="/dashboard" className="flex items-center gap-3 px-2 py-2 hover:bg-indigo-100 rounded w-full">
            <FontAwesomeIcon icon={faCog} className="text-indigo-600 text-lg" />
            {sidebarOpen && <span>Dashboard</span>}
          </Link>

          <Link to="/employees" className="flex items-center gap-3 px-2 py-2 hover:bg-indigo-100 rounded w-full">
            <FontAwesomeIcon icon={faUser} className="text-indigo-600 text-lg" />
            {sidebarOpen && <span>Υπάλληλοι</span>}
          </Link>

          <Link to="/customers" className="flex items-center gap-3 px-2 py-2 hover:bg-indigo-100 rounded w-full">
            <FontAwesomeIcon icon={faUserPlus} className="text-indigo-600 text-lg" />
            {sidebarOpen && <span>Πελάτες</span>}
          </Link>

          <Link to="/services" className="flex items-center gap-3 px-2 py-2 hover:bg-indigo-100 rounded w-full">
            <FontAwesomeIcon icon={faHandsHelping} className="text-indigo-600 text-lg" />
            {sidebarOpen && <span>Υπηρεσίες</span>}
          </Link>

          {/* ✅ Logout */}
          <button
            onClick={handleLogout}
            className="flex items-center gap-3 px-2 py-2 hover:bg-red-100 text-red-600 rounded w-full mt-8"
          >
            <FontAwesomeIcon icon={faSignOutAlt} className="text-red-600 text-lg" />
            {sidebarOpen && <span>Αποσύνδεση</span>}
          </button>
        </nav>
      </aside>

      {/* Main content */}
      <div className={`flex-1 flex flex-col transition-all duration-300 ${sidebarOpen ? 'ml-64' : 'ml-16'}`}>
        <main className="p-4 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default SidebarLayout;
